import React, { useState } from "react";
import "./Footer.css";

export default function Footer({
  officeTitle = "VĂN PHÒNG CHÍNH SIAM TRAVEL",
  address = "181 Phạm Ngũ Lão, Quận 1, Thành phố Hồ Chí Minh, 700000, Việt Nam",
  phone = "(+84) 941297 219",
  email = "raumuongluoc171@gmail.com",
  socials = {
    facebook: "#",
    instagram: "#",
    google: "#",
  },
  onSubmit, // optional: (formData)=>{}
}) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const setField = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) return onSubmit(form);
    // fallback: demo
    alert("Đã gửi thông tin!\n" + JSON.stringify(form, null, 2));
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <section className="ct-wrap" id="contact">
      <div className="ct-inner">
        <h2 className="ct-title">Liên hệ với chúng tôi</h2>

        <div className="ct-grid">
          {/* LEFT */}
          <div className="ct-left">
            <h3 className="ct-sub">{officeTitle}</h3>

            <div className="ct-info">
              <div className="ct-row">
                <span className="ct-label">Địa chỉ:</span>
                <span className="ct-value">{address}</span>
              </div>
              <div className="ct-row">
                <span className="ct-label">Trang web:</span>
                <span className="ct-value">http://rutthetindunghcm.com/</span>
              </div>
              <div className="ct-row">
                <span className="ct-label">Điện thoại:</span>
                <a
                  className="ct-link"
                  href={`tel:${phone.replace(/\s+/g, "")}`}
                >
                  {phone}
                </a>
              </div>

              <div className="ct-row">
                <span className="ct-label">Email:</span>
                <a className="ct-link" href={`mailto:${email}`}>
                  {email}
                </a>
              </div>
            </div>

            <div className="ct-socials">
              <a
                className="ct-social ct-fb"
                href={socials.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                f
              </a>
              <a
                className="ct-social ct-ig"
                href={socials.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                ⌁
              </a>
              <a
                className="ct-social ct-gg"
                href={socials.google}
                target="_blank"
                rel="noreferrer"
                aria-label="Google"
              >
                G
              </a>
            </div>

            <div className="ct-copy">Bản quyền thuộc về Siam Travel</div>
          </div>

          {/* RIGHT */}
          <div className="ct-right">
            <form className="ct-form" onSubmit={handleSubmit}>
              <input
                className="ct-input"
                placeholder="Tên"
                value={form.name}
                onChange={(e) => setField("name", e.target.value)}
                required
              />
              <input
                className="ct-input"
                placeholder="E-mail"
                type="email"
                value={form.email}
                onChange={(e) => setField("email", e.target.value)}
                required
              />
              <input
                className="ct-input"
                placeholder="Số điện thoại"
                value={form.phone}
                onChange={(e) => setField("phone", e.target.value)}
              />
              <textarea
                className="ct-textarea"
                placeholder="Tin nhắn"
                value={form.message}
                onChange={(e) => setField("message", e.target.value)}
                rows={7}
              />
              <button className="ct-btn" type="submit">
                Hỏi thông tin
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
